import type { ReactNode } from "react";
import useScrollProgress from "./useScrollProgress";

// história do fundador, em primeira pessoa: o storytelling da página.
// cada parágrafo "acende" conforme o scroll, com destaques em serif.
const STORY: ReactNode[] = [
  <>
    eu já tinha minha <span className="e21-serif">rotina</span> montada.
    treino, projetos, empreender, sempre buscando evoluir.
  </>,
  <>
    o que faltava era <span className="e21-serif">gente do meu lado</span>{" "}
    nessa. uma galera com a mesma rotina, os mesmos objetivos, puxando junto.
  </>,
  <>
    aí pensei: por que não juntar quem já me acompanha e pensa parecido
    comigo, e construir isso <span className="e21-serif">de verdade</span>?
  </>,
  <>
    o escape21 é o começo disso. 21 dias, todo mundo{" "}
    <span className="e21-serif">junto</span>, começando na segunda dia 27/07.
    4 hábitos por dia, tu marca o check-in e segue. e eu tô dentro fazendo
    tudo contigo.
  </>,
];

const WhatIs = () => {
  const [sectionRef, progress] = useScrollProgress();

  const eased = Math.min(1, Math.max(0, (progress - 0.1) / 0.8));
  const active = Math.min(STORY.length - 1, Math.floor(eased * STORY.length));
  // parallax leve na foto
  const photoY = (0.5 - progress) * 20;

  return (
    <section ref={sectionRef} className="relative h-[300vh]">
      <div className="sticky top-0 flex h-svh items-center justify-center px-6">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-6 sm:flex-row sm:items-center sm:gap-12">
          {/* foto do fundador: avatar no mobile, retrato no desktop */}
          <div
            className="flex-none will-change-transform"
            style={{ transform: `translateY(${photoY}px)` }}
          >
            <img
              src="/escape21/foto-fundador.jpg"
              alt="foto do fundador do escape21"
              loading="lazy"
              className="h-24 w-24 rounded-full border border-black/10 bg-neutral-100 object-cover object-[50%_22%] sm:h-auto sm:w-[250px] sm:rounded-2xl sm:aspect-[4/5]"
            />
          </div>

          <div className="text-center sm:text-left">
            <h2 className="text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
              por que eu criei isso.
            </h2>
            <div className="mt-6 space-y-4 sm:mt-8 sm:space-y-5">
              {STORY.map((paragraph, i) => (
                <p
                  key={i}
                  className={`text-[15px] leading-relaxed transition-all duration-500 sm:text-lg ${
                    i === active
                      ? "font-semibold opacity-100 blur-0"
                      : "opacity-25 blur-[1px]"
                  }`}
                >
                  {paragraph}
                </p>
              ))}
            </div>
            <span className="mt-6 inline-block font-mono text-sm tabular-nums text-black/40">
              {active + 1}/4
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIs;
